import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
// import NavigationTitle from "@components/NavigationTitle";
import NewText from "@components/NewText";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// GlobalNavbar => Rename all instances to use
type GlobalNavbarProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _GlobalNavbar = (props: GlobalNavbarProps) => {
  return (
    <div className={props.className}>
      {/* <NavigationTitle _autoChange={false} /> */}

      <NewText
        _text={
          "|{*}|Brian Woolfolk|| (|{=:https://github.com/brian101016,@:_link-2}|brian101016||) projects"
        }
        _type={"title"}
        _variant={2}
        _align={"center"}
        _styleText={{
          _link: {},
          _emphasis: {},
        }}
      />

      <NewText
        _text={"Home page"}
        _type={"subtitle"}
        _style={{ marginLeft: "1.5rem" }}
        _this={{
          _bold: {},
          _link: {
            _to: "/",
            _as: "2",
          },
          _custom: {
            _add: "backwards",
          },
        }}
      />
    </div>
  );
};

// ################################ STYLES ################################
const GlobalNavbar = styled(_GlobalNavbar).attrs((props): GlobalNavbarProps => {
  return { ...props };
})`
  ${(props) => css`
    background-color: #a9a9a982;
    backdrop-filter: blur(10px);
    box-shadow: 0px 0px 20px 0px darkgrey;

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default GlobalNavbar;
